<template>
    <div class="patent-ai-summary">
        <AccordionPanel label="AI Summary" id="family" type="ai-summary">
            <AonSkeleton
                class="w-100 display-flex align-items-center mb-sm flex-wrap"
                :loading="loadingPatentDetail"
                :data="0"
                :height="'80px'"
                light
            >
                <div class="holder">
                    <div
                        v-if="!loadingPatentDetail && noSummary"
                        class="no-patents h-100 display-flex align-items-center justify-center flex-wrap"
                    >
                        <p class="w-100 text-center">
                            No Ai Summary identified on all or parts of this patent
                        </p>
                    </div>
                    <AonCoverLoading :loading="loadingPatentDetail" title="Generating Summary" />
                    <div v-if="!noSummary" class="statements mt-md">
                        <div class="problems">
                            <p class="extra-small uppercase mb-sm bold">Problems</p>
                            <ul style="list-style: circle">
                                <li class="ml-xl mt-sm" v-for="item in aiSummary?.problems">
                                    <p class="small text-stone-700 m-sm d-inline">
                                        {{ item.description }}
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <div class="solutions">
                            <p class="extra-small uppercase mb-sm mt-xl bold">
                                Potential Solutions
                            </p>
                            <ul style="list-style: circle">
                                <li class="ml-xl mt-sm" v-for="item in aiSummary?.solutions">
                                    <p class="small text-stone-700 m-sm d-inline">
                                        {{ item.description }}
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <div class="benefits">
                            <p class="extra-small uppercase mb-sm mt-xl bold">Value</p>
                            <ul style="list-style: circle">
                                <li class="ml-xl mt-sm" v-for="item in aiSummary?.benefits">
                                    <p class="small text-stone-700 m-sm d-inline">
                                        {{ item.description }}
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </AonSkeleton>
        </AccordionPanel>
    </div>
</template>

<script setup>
import { computed, inject } from 'vue'
import { usePatentViewerStore } from '@/stores'
import AccordionPanel from '@/components/helpers/AccordionPanel.vue'

const patentViewerStore = usePatentViewerStore()

const props = defineProps({
    patentDetails: {
        type: Object,
        default: () => ({}),
    },
    loadingPatentDetail: {
        type: Boolean,
        default: false,
    },
})

const aiSummary = computed(() => {
    const patentId = props.patentDetails?.publicationPk
    if (!patentId) return null

    // If we have this summary in cache, return it
    if (patentViewerStore.aiSummaryExistsInCache(patentId)) {
        return patentViewerStore.getCachedAISummary(patentId)
    }

    // If not in cache, cache the current patent details
    if (props.patentDetails && !props.loadingPatentDetail) {
        const summary = {
            problems: props.patentDetails.problems || [],
            solutions: props.patentDetails.solutions || [],
            benefits: props.patentDetails.benefits || [],
        }
        patentViewerStore.setCachedAISummary(patentId, summary)
        return summary
    }

    return null
})

const noSummary = computed(() => {
    if (!aiSummary.value) return true
    if (aiSummary.value.problems?.length === 0) {
        return true
    }
    if (aiSummary.value.solutions?.length === 0) {
        return true
    }
    if (aiSummary.value.benefits?.length === 0) {
        return true
    }
    return false
})
</script>

<style lang="scss" scoped>
.patent-ai-summary {
}
</style>
